import React from 'react';
import IconInvoker from '../Icons/IconInvoker';
import './ButtonLink.scss';

const ButtonLink = ({className, disabled, title, href, isLoading = false, size = null, icon = null, width = null, onClick = false}) => (
    <a
        className={`${className} ${disabled && ' disabled'} ${size !== null && size}`}
        disabled={disabled}
        href={disabled ? '' : href }
        onClick={onClick}
        style={{minWidth: width ? width +'px' : 'initial', maxWidth:  width ? width +'px' : 'initial'}}
    >{isLoading && <i className="fa fa-spinner fa-spin"/>}
        <div className="btn-body">
            {icon && new IconInvoker(icon, 'm-r-15')}
            <span className="btn-title">{!isLoading && title}</span>
        </div>
    </a>
);

export default ButtonLink;


// WEBPACK FOOTER //
// ./src/components/Common/ButtonLink/ButtonLink.js